<template>
  <BaseFormLayout
    :title="`${editMode ? 'Edit' : 'Add'} ${customFieldModule.customField}`"
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #actions>
      <SecondaryButton
        id="customFieldReset"
        v-if="!editMode"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="customFieldSubmit"
        @click="submitForm()"
        :disabled="!isValid"
        btnClass="text-uppercase rounded-lg"
        name="Submit"
      >
      </PrimaryButton>
    </template>
    <template #content>
      <v-form
        v-model="isValid"
        ref="companyForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-card elevation="0" class="pa-4 rounded-lg">
          <v-row class="ma-0">
            <v-col cols="12">
              <span class="text-subtitle-1 font-weight-bold">Custom Field</span>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="4">
                  <SelectField
                    id="company"
                    :label="`${companyModule.company} *`"
                    :itemsList="companySelectList"
                    name="company"
                    :disabled="editMode"
                    item-text="name"
                    item-value="id"
                    v-model="customFieldDetails.company"
                    :rules="[(val) => !!val || 'Company is required']"
                    :error-messages="formErrors.company"
                    @input="delete formErrors.company"
                  />
                </v-col>
                <v-col cols="4">
                  <SelectField
                    v-model="customFieldDetails.module"
                    :itemsList="module"
                    itemText="display_value"
                    name="module"
                    itemValue="value"
                    :multiple="true"
                    label="Module *"
                    :rules="[
                      (val) =>
                        (!!val && val.length > 0) || 'Module is required',
                    ]"
                    :error-messages="formErrors.module"
                    @input="delete formErrors.module"
                  />
                </v-col>
                <v-col cols="4">
                  <SelectField
                    v-model="customFieldDetails.field_type"
                    :itemsList="fieldType"
                    itemText="display_value"
                    name="field_type"
                    itemValue="value"
                    label="Field Type *"
                    :rules="[(val) => !!val || 'Field Type is required']"
                    :error-messages="formErrors.field_type"
                    @change="
                      delete formErrors.field_type;
                      onChangeFieldType($event);
                      delete customFieldDetails.default;
                    "
                  />
                </v-col>
                <v-col cols="4">
                  <InputField
                    id="name"
                    v-model="customFieldDetails.name"
                    label="Name"
                    name="name"
                    :required="true"
                    :rules="[
                      (val) =>
                        (val && nameValidation(val)) ||
                        'Space and No special characters are allowed',
                    ]"
                    :error-messages="formErrors.name"
                    @input="delete formErrors.name"
                  />
                </v-col>
                <v-col cols="4">
                  <InputField
                    id="label"
                    v-model="customFieldDetails.label"
                    label="Label"
                    name="label"
                    :rules="[
                      (val) =>
                        (val && labelValidation(val)) ||
                        'No special characters are allowed',
                    ]"
                    :required="false"
                    :error-messages="formErrors.label"
                    @input="delete formErrors.label"
                  />
                </v-col>
                <v-col cols="4">
                  <SelectField
                    id="required"
                    v-model="customFieldDetails.required"
                    :itemsList="binaryChoice"
                    itemText="label"
                    itemValue="value"
                    label="Required"
                    name="required"
                    :required="true"
                    :error-messages="formErrors.required"
                    @input="delete formErrors.required"
                  />
                </v-col>
                <v-col
                  cols="4"
                  v-if="customFieldDetails.field_type == 'boolean_field'"
                >
                  <SelectField
                    id="default"
                    v-model="customFieldDetails.default"
                    :itemsList="defualtFieldBinaryChoice"
                    itemText="label"
                    itemValue="value"
                    label="Default Value"
                    name="default"
                    :required="false"
                    :error-messages="formErrors.default"
                    @input="delete formErrors.default"
                  />
                </v-col>
                <v-col
                  cols="4"
                  v-else-if="customFieldDetails.field_type == 'time_field'"
                >
                  <InputField
                    id="default"
                    type="time"
                    label="Default Value"
                    v-model="customFieldDetails.default"
                    :required="false"
                    name="default"
                    :error-messages="formErrors.default"
                    @input="delete formErrors.default"
                  />
                </v-col>
                <v-col
                  cols="4"
                  v-else-if="customFieldDetails.field_type == 'date_field'"
                >
                  <DatePicker
                    type="date"
                    id="default"
                    :required="false"
                    v-model="customFieldDetails.default"
                    hide-details="auto"
                    label="Default Value"
                    outlined
                    name="default"
                    :error-messages="formErrors.default"
                    @input="delete formErrors.default"
                  />
                </v-col>
                <v-col
                  cols="4"
                  v-else-if="customFieldDetails.field_type == 'date_time_field'"
                >
                  <DateTimeField
                    fieldType="datetime"
                    id="default"
                    v-model="customFieldDetails.default"
                    hide-details="auto"
                    :inputProps="{
                      label: 'Default Value',
                      'error-messages': formErrors.default,
                    }"
                    outlined
                    name="default"
                    @input="delete formErrors.default"
                  />
                </v-col>
                <v-col
                  cols="4"
                  v-if="
                    customFieldDetails.field_type != 'time_field' &&
                    customFieldDetails.field_type != 'date_field' &&
                    customFieldDetails.field_type != 'date_time_field' &&
                    customFieldDetails.field_type != 'boolean_field' &&
                    customFieldDetails.field_type != 'select' &&
                    customFieldDetails.field_type != 'multi_select'
                  "
                >
                  <InputField
                    id="default"
                    v-model="customFieldDetails.default"
                    label="Default Value"
                    name="default"
                    :required="false"
                    :error-messages="formErrors.default"
                    @input="delete formErrors.default"
                  />
                </v-col>
                <v-col cols="4">
                  <InputField
                    id="prefix"
                    v-model="customFieldDetails.prefix"
                    label="Prefix"
                    name="prefix"
                    :required="false"
                    :error-messages="formErrors.prefix"
                    @input="delete formErrors.prefix"
                  />
                </v-col>
                <v-col cols="4">
                  <InputField
                    id="suffix"
                    v-model="customFieldDetails.suffix"
                    label="Suffix"
                    name="suffix"
                    :required="false"
                    :error-messages="formErrors.suffix"
                    @input="delete formErrors.suffix"
                  />
                </v-col>
                <v-col
                  cols="4"
                  v-if="
                    customFieldDetails.field_type === 'integer_field' ||
                    customFieldDetails.field_type ===
                      'positive_integer_field' ||
                    customFieldDetails.field_type === 'float_field'
                  "
                >
                  <InputField
                    id="min_value"
                    type="number"
                    v-model="customFieldDetails.min_value"
                    label="Minimum Value"
                    name="min_value"
                    :required="false"
                    :rules="
                      !!customFieldDetails.default &&
                      !!customFieldDetails.min_value
                        ? minimumRules
                        : []
                    "
                    :error-messages="formErrors.min_value"
                    @input="delete formErrors.min_value"
                  />
                </v-col>
                <v-col
                  cols="4"
                  v-if="
                    customFieldDetails.field_type === 'integer_field' ||
                    customFieldDetails.field_type ===
                      'positive_integer_field' ||
                    customFieldDetails.field_type === 'float_field'
                  "
                >
                  <InputField
                    id="max_value"
                    type="number"
                    v-model="customFieldDetails.max_value"
                    label="Maximum Value"
                    name="max_value"
                    :required="false"
                    :rules="
                      !!customFieldDetails.default &&
                      !!customFieldDetails.max_value
                        ? maximumRules
                        : []
                    "
                    :error-messages="formErrors.max_value"
                    @input="delete formErrors.max_value"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              v-if="
                customFieldDetails.field_type == 'select' ||
                customFieldDetails.field_type == 'multi_select'
              "
            >
              <v-row>
                <v-col cols="12" class="d-flex justify-space-between">
                  <span class="font-weight-bold">Add Choices</span>
                  <PrimaryButton name="Add Choice" @click="addChoice" />
                </v-col>
                <v-col
                  cols="3"
                  v-for="(val, index) in customFieldDetails.choices"
                  :key="index"
                  class="d-flex align-center justify-space-between"
                >
                  <InputField
                    :id="`Choice ${index + 1}`"
                    :label="`Choice ${index + 1}`"
                    :value="val"
                    :required="true"
                    :error-messages="formErrors.max_value"
                    @input="customFieldDetails.choices[index] = $event"
                  />
                  <v-icon
                    color="error"
                    v-if="
                      customFieldDetails &&
                      customFieldDetails.choices &&
                      customFieldDetails.choices.length > 1
                    "
                    class="ml-2"
                    @click="removeChoice(index)"
                    >mdi-delete</v-icon
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col
              v-if="
                formErrors &&
                formErrors.choices &&
                formErrors.choices.length > 0
              "
            >
              <v-alert color="error white--text py-2">
                {{ formErrors.choices[0] }}</v-alert
              >
            </v-col>
          </v-row>
        </v-card>
      </v-form>
    </template>
  </BaseFormLayout>
</template>

<script>
import { bus } from "@/main.js";
import { emailValidation } from "@/utils/functions.js";
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import { customFieldModule, companyModule } from "@/utils/moduleMapping";
import { timezones } from "@/utils/fieldConstants.js";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
  },
  components: {
    BaseFormLayout,
  },
  data() {
    return {
      customFieldModule,
      companyModule,
      emailValidation,
      formCount: 0,
      isValid: true,
      customFieldDetails: {},
      formErrors: {},
      companySelectList: [],
      module: [],
      fieldType: [],
      binaryChoice: [
        { label: "True", value: true },
        {
          label: "False",
          value: false,
        },
      ],
      defualtFieldBinaryChoice: [
        { label: "True", value: "true" },
        {
          label: "False",
          value: "false",
        },
      ],
    };
  },
  computed: {
    minimumRules() {
      return [
        parseFloat(this.customFieldDetails.min_value) <=
          parseFloat(this.customFieldDetails.default) ||
          `Minimum value must be lesser than default value`,
      ];
    },
    maximumRules() {
      return [
        parseFloat(this.customFieldDetails.default) <=
          parseFloat(this.customFieldDetails.max_value) ||
          `Maximum value must be greater than default value`,
      ];
    },
  },
  methods: {
    onChangeFieldType(value) {
      if (value != "integer_field" && value != "positive_integer_field") {
        delete this.customFieldDetails.min_value;
        delete this.customFieldDetails.max_value;
      }
      if (value != "select" && value != "multi_select") {
        delete this.customFieldDetails.choices;
        this.formCount++;
      } else if (value == "select" || value == "multi_select") {
        this.customFieldDetails.choices = [""];
      }
    },
    removeChoice(index) {
      let arr = [...this.customFieldDetails.choices];
      arr.splice(index, 1);
      this.customFieldDetails.choices = [...arr];
      this.formCount++;
    },
    addChoice() {
      let arr = [...this.customFieldDetails.choices];
      arr.push("");
      this.customFieldDetails.choices = [...arr];
      this.formCount++;
    },
    async getCompanySelectList() {
      bus.$emit("showLoader", true);
      await this.$api.company
        .getCompanySelectList({
          limit: "all",
        })
        .then((res) => {
          this.companySelectList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    async getCustomFieldOptions() {
      bus.$emit("showLoader", true);
      await this.$api.customField
        .getCustomFieldsOption({ request_type: "form" })
        .then((res) => {
          this.fieldType = res?.data?.field_type;
          this.module = res?.data?.module;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    async getCustomFieldObject(id) {
      await this.$api.customField
        .getCustomFieldsObject(id)
        .then((res) => {
          this.customFieldDetails = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetForm() {
      this.$refs.companyForm.reset();
    },
    nameValidation(string) {
      let validRegex = /^[a-zA-Z0-9_-]+$/i;
      return validRegex.test(string);
    },
    labelValidation(string) {
      let validRegex = /^[a-zA-Z0-9-_ ]+$/i;
      return validRegex.test(string);
    },
    submitForm() {
      if (!this.$refs.companyForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      if (this.editMode) {
        this.$api.customField
          .updateCustomFieldsObject({
            id: this.customFieldDetails.id,
            data: { ...this.customFieldDetails },
          })
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Custom Field information updated!",
              color: "success",
            });
            this.resetForm();
            this.$router.back();
          })
          .catch((err) => {
            console.log(err);
            this.formErrors = err.data;
          });
      } else {
        this.$api.customField
          .createCustomFieldsObject({ ...this.customFieldDetails })
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Custom Field created!",
              color: "success",
            });
            this.resetForm();
            this.$router.back();
          })
          .catch((err) => {
            this.formErrors = err.data;
          });
      }
    },
  },
  async mounted() {
    await this.getCustomFieldOptions();
    await this.getCompanySelectList();
    if ("id" in this.$route.params) {
      await this.getCustomFieldObject(this.$route.params.id);
    }
  },
};
</script>

<style>
.v-select__slot label {
  z-index: 2;
}
</style>
